import React, { useEffect, useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import { Copy, FileJson, Info, ListCheck, Loader } from "lucide-react";
import {
    verifyOcrGenericKYC,
  verifyOcrPassport,
  verifyPrefillDetails,
} from "../../../Services/ApiTestService/apiTestService";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { isNumeric, isAlpha } from "validator";

function OcrGenericKyc() {
  const { serviceName } = useService();

  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [inputError, setInputError] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(null);

  const [file, setFile] = useState("");

  const [profileData, setProfileData] = useState(null);
  let apiResponse;

  const isNumber = (value) => {
    if (!value) return false;

    return isNumeric(value, { no_symbols: true });
  };

  const isAlphabetic = (value) => {
    if (!value) return;

    return isAlpha(String(value).trim(), "en-IN", { ignore: " " });
  };

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data, null, 2))
      .then(setIsJsonCopied(true));
    showSuccessToast("Text Copied");
  };
  // ---------------- VERIFY CONSUMER ----------------
  const handleVerifyConsumer = async () => {
    if (!profileData) return;

    try {
      setIsLoading(true);
      setResponse(null);
      setInputError(null);

      const formData = new FormData();

      formData.append("api_key", profileData.api_key);
      formData.append("api_id", profileData.user_id);
      formData.append("token_id", profileData.token_id);
      formData.append("pdf", file);

      const res = await verifyOcrGenericKYC(formData);

      if (res) {
        apiResponse = res;
        setResponse(apiResponse);
        console.log(res);
      }

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "request successful");
      } else if (res?.status?.code === 422) {
        showErrorToast(response?.message || "Invalid format");
      } else if (res?.status?.code === 500) {
        showErrorToast(res?.data?.message || "server error");
      } else if (!response.success) {
        showErrorToast(response?.data?.message || "verificaton failed");
      } else if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else {
        showErrorToast(res?.status?.message || "Verification failed");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={'Ocr Generic kyc'} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center py-14">
        {/* ---------------- FORM ---------------- */}
        <div className=" max-w-3xl border rounded-md p-4 sm:p-6 mt-6 bg-white">
          <div className="flex flex-wrap gap-4">
            <div>
              <input
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>
            {/* input errors */}

            {inputError && (
              <div className="text-red-700 text-xl font-bold">{inputError}</div>
            )}

            {/* Verify Button */}
            <div className="flex justify-end mt-2">
              <button
                disabled={isLoading || !file}
                onClick={handleVerifyConsumer}
                className="px-6 py-2 bg-gradient-to-br active:from-green-600 active:to-green-700 from-blue-400 to-blue-800 text-white rounded-sm disabled:opacity-50"
              >
                Verify
              </button>
            </div>
          </div>
        </div>

        {response && (
          <div
            className={` ${response.status?.code === 500 || response.status?.code === 422 ? "text-red-500" : "text-green-600"} py-4 text-2xl font-bold`}
          >
            {response?.data?.message || response?.message}
          </div>
        )}

        {/* instructions */}

        <div>
          <div className="bg-green-50 text-green-800 border border-green-400 p-5 mt-12 rounded-md">
            <h3 className="font-bold text-lg mb-2 flex items-center gap-2 justify-start">
              <Info />
              Important Instructions <span className="text-red-600">*</span>
            </h3>

            <p className="text-sm leading-relaxed">
              Please add PDF containing KYC Document id. clicking the Verify button.
              After successful verification, the system will return the response
              in structured format, including contact details associated with
              the provided details. You may review and copy the data for your
              reference or further use.
            </p>
          </div>
        </div>
        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 w-full max-w-6xl">
            {/* -------- JSON VIEW -------- */}
            <div className="bg-gray-900 relative text-green-300 p-4 rounded-md overflow-auto">
              <button
                onClick={() => handleCopy(response)}
                className="absolute text-white top-4 right-8"
              >
                {isJsonCopied ? "copied" : <Copy />}
              </button>
              <p className="font-bold mb-2 text-2xl flex items-center justify-start md:justify-center gap-2 text-white">
                <FileJson /> JSON response
              </p>
              <hr className="mb-8" />{" "}
              <pre className="text-[16px]">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>

           {/* -------- USER DETAILS -------- */}
<div className="bg-gray-200 p-5 rounded-md">
  <h2 className="text-2xl flex items-center justify-center gap-2 font-bold text-blue-500 mb-1">
    <ListCheck /> All Details
  </h2>
  <hr className="mb-8" />

  {response?.status?.code === 200 &&
    response?.data?.length > 0 &&
    response.data.map((item, index) => {
      const details = item.details;

      return (
        <div key={index} className="space-y-2 text-sm mb-6">

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Document Type:
            </span>
            <span className="text-gray-900">{item.type}</span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Passport No:
            </span>
            <span className="text-gray-900">
              {details?.passport_num?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Given Name:
            </span>
            <span className="text-gray-900">
              {details?.given_name?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Surname:
            </span>
            <span className="text-gray-900">
              {details?.surname?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Gender:
            </span>
            <span className="text-gray-900">
              {details?.gender?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Date of Birth:
            </span>
            <span className="text-gray-900">
              {details?.dob?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Date of Issue:
            </span>
            <span className="text-gray-900">
              {details?.doi?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Date of Expiry:
            </span>
            <span className="text-gray-900">
              {details?.doe?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Nationality:
            </span>
            <span className="text-gray-900">
              {details?.nationality?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Country Code:
            </span>
            <span className="text-gray-900">
              {details?.country_code?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Place of Birth:
            </span>
            <span className="text-gray-900">
              {details?.place_of_birth?.value || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              Place of Issue:
            </span>
            <span className="text-gray-900">
              {details?.place_of_issue?.value || "N/A"}
            </span>
          </div>

          {/* MRZ Lines */}
          <div className="pt-3">
            <span className="font-semibold text-gray-600 w-44 inline-block">
              MRZ Line 1:
            </span>
            <span className="text-gray-900 break-all">
              {details?.mrz?.line1 || "N/A"}
            </span>
          </div>

          <div>
            <span className="font-semibold text-gray-600 w-44 inline-block">
              MRZ Line 2:
            </span>
            <span className="text-gray-900 break-all">
              {details?.mrz?.line2 || "N/A"}
            </span>
          </div>

        </div>
      );
    })}
</div>

          </div>
        )}
      </div>
    </>
  );
}

export default OcrGenericKyc;
